import React from 'react';
import Icon from '../Icon';
import EligibilityForm from './EligibilityForm';

const EligibilityTop = () => (
  <section className="elig-top">
    <div className="container">
      <div className="elig-top-head">
        <span className="eyebrow eyebrow-coral">
          <Icon name="sparkle" size={12} stroke={2.5}/> 2-minute eligibility check
        </span>
        <h1>See what you could earn <em>in just a few questions.</em></h1>
        <p className="lede">
          We'll match you to your state's program and tell you what you may be eligible for.
          No SSN. No credit pull. No obligation.
        </p>
      </div>

      <EligibilityForm />

      <div className="elig-trust-row">
        <span className="item"><Icon name="lock" size={13} stroke={2.2}/> 256-bit SSL</span>
        <span className="item"><Icon name="shield" size={13} stroke={2.2}/> HIPAA-compliant</span>
        <span className="item"><Icon name="check-bold" size={13} stroke={2.4}/> No SSN required</span>
        <span className="item"><Icon name="check-bold" size={13} stroke={2.4}/> 100% confidential</span>
      </div>
    </div>
  </section>
);

export default EligibilityTop;
